import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart3, Users, FolderKanban, FileText, DollarSign, Settings } from 'lucide-react';

export default function AdminDashboard() {
  const dashboardCards = [
    {
      title: "Projects",
      description: "Manage all projects and assessments",
      icon: <FolderKanban className="w-8 h-8" />,
      href: "/admin/projects",
      color: "text-blue-400"
    },
    {
      title: "Users",
      description: "User management and permissions",
      icon: <Users className="w-8 h-8" />,
      href: "/admin/users", 
      color: "text-green-400"
    },
    {
      title: "Assessments Report",
      description: "View and export assessment analytics",
      icon: <BarChart3 className="w-8 h-8" />,
      href: "/admin/assessments-report",
      color: "text-[#4AE2C9]"
    },
    {
      title: "Pricing Matrix",
      description: "Configure pricing and revenue bands",
      icon: <DollarSign className="w-8 h-8" />,
      href: "/admin/pricing-matrix",
      color: "text-yellow-400"
    },
    {
      title: "Export History",
      description: "Track and audit all exports",
      icon: <FileText className="w-8 h-8" />,
      href: "/admin/exports",
      color: "text-purple"
    },
    {
      title: "System Settings",
      description: "Platform configuration and settings",
      icon: <Settings className="w-8 h-8" />,
      href: "/admin/system-settings",
      color: "text-gray-400"
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white">Admin Dashboard</h1>
        <p className="text-gray-400">Manage the Redwood Value Assessment platform</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {dashboardCards.map((card, index) => (
          <Card key={index} className="bg-gray-800 border-gray-700 hover:bg-gray-700 transition-colors cursor-pointer">
            <CardHeader>
              <div className="flex items-center gap-4">
                <div className={card.color}>
                  {card.icon}
                </div>
                <div>
                  <CardTitle className="text-white">{card.title}</CardTitle>
                  <CardDescription className="text-gray-400">
                    {card.description}
                  </CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <a 
                href={card.href}
                className="inline-flex items-center text-sm text-[#4AE2C9] hover:text-[#4AE2C9]/80 transition-colors"
              >
                Manage →
              </a>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="bg-gray-800 border-gray-700">
          <CardHeader>
            <CardTitle className="text-white">Quick Stats</CardTitle>
            <CardDescription className="text-gray-400">
              Platform overview metrics
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-gray-300">Active Projects</span>
                <span className="text-[#4AE2C9] font-semibold">25</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-300">Total Users</span>
                <span className="text-[#4AE2C9] font-semibold">14</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-300">Completed Assessments</span>
                <span className="text-[#4AE2C9] font-semibold">19</span>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-gray-800 border-gray-700">
          <CardHeader>
            <CardTitle className="text-white">Recent Activity</CardTitle>
            <CardDescription className="text-gray-400">
              Latest platform activity
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <div className="text-sm">
                <div className="text-white">Assessment completed</div>
                <div className="text-gray-400 text-xs">SimonTestA - 2 hours ago</div>
              </div>
              <div className="text-sm">
                <div className="text-white">New project created</div>
                <div className="text-gray-400 text-xs">Fresha - 1 day ago</div>
              </div>
              <div className="text-sm">
                <div className="text-white">Export generated</div>
                <div className="text-gray-400 text-xs">Spreadsheet Test - 2 days ago</div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}